var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSwap = function SvgIconSwap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.763 3.263A1.75 1.75 0 0 1 9 2.75h10.5a1.75 1.75 0 0 1 1.75 1.75v9.75A1.75 1.75 0 0 1 19.5 16H9.914l.543.543a1 1 0 0 1-1.414 1.414l-2.25-2.25a1 1 0 0 1 0-1.414l2.25-2.25a1 1 0 0 1 1.414 1.414L9.914 14h9.336V4.75h-10v.5a1 1 0 0 1-2 0V4.5c0-.464.184-.91.513-1.237"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.543 6.043a1 1 0 0 1 1.414 0l2.25 2.25a1 1 0 0 1 0 1.414l-2.25 2.25a1 1 0 0 1-1.414-1.414l.543-.543H4.75v9.25h10v-.5a1 1 0 1 1 2 0v.75A1.75 1.75 0 0 1 15 21.25H4.5a1.75 1.75 0 0 1-1.75-1.75V9.75A1.75 1.75 0 0 1 4.5 8h9.586l-.543-.543a1 1 0 0 1 0-1.414"
  }))));
};
export default SvgIconSwap;